import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from 'govuk-react-jsx';
import { useSelector } from 'react-redux';
import {
  getSocketAllocationPage,
  getNumberOfChargepointsSocketsInstalled,
} from '../../features/installer/installerJourneySlice';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import { getChargePointDetails } from '../../firebase';
import { getApplicationDocumentId } from '../../features/application/applicationJourneySlice';
import useTitle from '../../hooks/useTitle';

const OverAllocationOfSockets = () => {
  const history = useHistory();
  const socketAllocationPageRedux = useSelector(getSocketAllocationPage);
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;
  useTitle(
    'installer.OverAllocationOfSockets.s7',
    'You have exceeded the number of sockets you can claim - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );
  const applicationDocumentId = useSelector(getApplicationDocumentId);
  const installedSockets = useSelector(getNumberOfChargepointsSocketsInstalled);
  const [socketApplied, setSocketApplied] = useState('');
  // const [socketInstalled, setSocketInstalled] = useState('');

  useEffect(() => {
    getChargePointDetails({ applicationDocumentId }).then((response) => {
      const { data } = response;

      setSocketApplied(data.number_of_chargepoint_sockets_applied);
      // setSocketInstalled(data.number_of_chargepoint_sockets_installed);
    });
  }, []);
  const handleReturnButton = () => {
    // If the user arrived on the Over Allocation screen via chargepoint details EVCG-247,
    // they will be directed to the summary screen described in EVCG-76
    if (socketAllocationPageRedux === 'chargepointModelDetails') {
      history.push('/installer/chargepoints-details');
    } else {
      history.push('/installer/chargepoints-summary');
    }
  };

  const pageModel = (
    <div>
      <h1 className="govuk-heading-l">
        {copyProvider.getCopy(
          'installer.OverAllocationOfSockets.s1',
          'You have exceeded the number of sockets you can claim for'
        )}
      </h1>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'installer.OverAllocationOfSockets.s2',
          'Your customer has applied for a total of '
        )}
        {socketApplied}
        {copyProvider.getCopy(
          'installer.OverAllocationOfSockets.s3',
          ' chargepoint sockets. That is the total amount you can claim for.'
        )}
      </p>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'installer.OverAllocationOfSockets.s4',
          '  If you have installed '
        )}
        {installedSockets}
        {copyProvider.getCopy(
          'installer.OverAllocationOfSockets.s5',
          ' chargepoint sockets, you will need to contact your customer and advise them to amend their grant application'
        )}
      </p>
      <div className="govuk-button-group govuk-!-margin-top-9">
        <Button className="govuk-button" onClick={handleReturnButton}>
          {copyProvider.getCopy(
            'installer.OverAllocationOfSockets.s6',
            'Return and review'
          )}
        </Button>
      </div>
    </div>
  );
  return pageModel;
};

export default OverAllocationOfSockets;
